import { useEffect, useState } from 'react';

import { MUTED_GRAY } from '../constants';

interface PingFluctuationProps {
  baseMs: number;
  variance: number;
  color: string;
  label: string;
}

export function PingFluctuation({ baseMs, variance, color, label }: PingFluctuationProps) {
  const [currentPing, setCurrentPing] = useState(baseMs);

  useEffect(() => {
    const interval = setInterval(() => {
      const fluctuation = Math.floor(Math.random() * variance * 2) - variance;
      setCurrentPing(Math.max(1, baseMs + fluctuation));
    }, 800);
    return () => clearInterval(interval);
  }, [baseMs, variance]);

  return (
    <div className='text-center'>
      <div className='font-mono text-4xl font-black tabular-nums md:text-5xl' style={{ color }}>
        {currentPing}
        <span className='text-lg font-normal opacity-60'>ms</span>
      </div>
      <span className='mt-1 block text-xs uppercase tracking-widest' style={{ color: MUTED_GRAY }}>
        {label}
      </span>
    </div>
  );
}
